import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SharedService } from 'src/app/services/shared/shared.service';
import { SimpleDialogComponent } from 'src/app/shared/component/simplecomponent/simplecomponent.component';
import { ConfigParamService } from '../../../services/ksa/config-param/config-param.service'
import { RolesService } from '../../roles.service';
import { StorageService } from '../../storage.service';
@Injectable({
    providedIn: 'root'
})
export class KsaAdminGuard {
    groupcode: any;
    allGroupCodes: any;
    currentGroupCode: null;
    selectedGroupCode: any;
    newGroupCode: any;
    ref: DynamicDialogRef | undefined;

    constructor(private storageService: StorageService,private rolesService: RolesService, private router: Router, public sharedService: SharedService, public dialogService: DialogService, private ConfigParamService: ConfigParamService) {
        //     this.sharedService.groupCodeChangeObserve().subscribe((res) => {
        // this.groupcode = res;
        //     })
    }
    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

            let country = this.storageService.decodeValue("Country");
            if (country == "KSA") {
        return new Promise((res) => {

            // setTimeout(() => {
                this.rolesService.getAdminUser().subscribe(
                    (resp: any) => {
                        console.log(resp)
                        if (resp.hdr.status == 'S') {
                            res(true);
                        } else {
                            // alert("Please reach out to helpdesk for assistance/support");
                            console.log("error in api call for getAdminUser");
                            // location.reload();
                            res(false);
                        }
                    },
                    (err) => {
                        // alert("Please reach out to helpdesk for assistance/support");
                        console.log("error in api call for getAdminUser");
                        // location.reload();
                        res(false);
                    })
            // }, 1000);

           
        });

    }
    }


}


